import React, {PureComponent} from 'react';

class ModalPanel extends PureComponent {
  render () {
    return <div>这是最后一层Modal啦！</div>
  }
}

export default ModalPanel;


// WEBPACK FOOTER //
// ./src/AntD/pages/example/multModal/modalPanel.js